import { NgClass, NgFor } from "@angular/common";
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, input, OnInit, signal, viewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IMapLegendItem } from "./IMapLegendItem";

@Component({
  selector: "bi-map-legend",
  templateUrl: "./bi-map-legend.component.html",
  styleUrls: ["./bi-map-legend.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgFor, FormsModule],
  host: {
    id: "bi-map-legend"
  }
})
export class BiMapLegendComponent implements OnInit, AfterViewInit {
  readonly legendItems = input<IMapLegendItem[]>();

  readonly legendItemContainer = viewChild<ElementRef<HTMLDivElement>>("legendItemsContainer");

  /**
   * Callback funtion being fired when selection/activation state of items has changed.
   * Passed value is an array of number values being the IDs identifying the groups of map markers to show. (e.g. a list of profile IDs);
   */
  public onSelectionChanged: (mapMarkerGroupIdentifierKeys: Array<number>) => void;

  public itemWrapperCssClasses = signal("flex ");

  public ngOnInit() {
    if (!this.legendItems() || this.legendItems().length === 0) throw "BiMapLegendComponent says: I have no legendItems!";
    if (!this.onSelectionChanged) throw "BiMapLegendComponent says: Please provide a callback for onSelectionChanged!!";
  }

  public ngAfterViewInit() {
    if (this.legendItemContainer().nativeElement.scrollWidth > window.innerWidth || this.legendItemContainer().nativeElement.scrollWidth > window.screen.availWidth)
      this.itemWrapperCssClasses.update(currentVal => (currentVal += "align-items-center overflow-x-scroll overflow-y-hidden"));
    else this.itemWrapperCssClasses.update(currentVal => (currentVal += "align-items-center justify-content-center"));
  }

  public onActivationSateChanged(item: IMapLegendItem) {
    item.enabled = !item.enabled;
    const activatedItems = this.legendItems()
      .filter(i => i.enabled)
      .map(i => i.mapMarkerGroupIdentifierKey);
    this.onSelectionChanged(activatedItems);
  }
}
